webpackJsonp([169076919976411],{

/***/ 1367:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Mitch Robertson","slug":"blog/author/mitch-robertson","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/mitch-robertson"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-mitch-robertson-d33ab454d3e46a3939b4.js